/* eslint-disable no-param-reassign */
import * as THREE from 'three';
import { Scene, Clouds, Environment, ItemManager, Cameras, } from '../base';
import * as webcad from '../../webcad';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { ThreeView } from './View3dWebCad';

/* WebCadClouds
 * WebCad用雲オブジェクト.
 */
export class WebCadClouds extends Clouds {
  public getCloudTextureUrl(isNight: boolean): string {
    return webcad.WebCADGlobal.webcad2Dmanager.assets_url + super.getCloudTextureUrl(isNight);
  }
}

/* WebCadEnvironment
 * WebCad用環境オブジェクト.
 */
export class WebCadEnvironment extends Environment {
  static _fogOrbitDensity: number = 0.008;

  static _fogWalkThruDensity: number = 0.05;

  static _fogNightDensity: number = 0.0;

  private _fog: THREE.FogExp2;

  private _camValue: number;

  constructor() {
    super();

    this.sky.sun.me.name = '太陽光';
    this.sky.sun.me.color = new THREE.Color(0xfffffe);
    this.sky.sun.me.intensity = 0;
    // this.sky.sun.me.intensity = 0.8;
    // this.sky.sun.me.intensity = 0.63;

    this.sky.ambient.me.name = '環境光';
    this.sky.ambient.me.color = new THREE.Color(0xffffff);
    this.sky.ambient.me.intensity = 0;
    // this.sky.ambient.me.intensity = 0.15; // <-- 0.34
    // this.sky.ambient.me.intensity = 0.35; // <-- 0.34

    this._fog = new THREE.FogExp2(0xffffff, WebCadEnvironment._fogOrbitDensity);
    this._camValue = 0;
  }

  public setNight(value: boolean): void {
    super.setNight(value);
    this.cameraChanged(this._camValue);
  }

  protected createClouds(): Clouds {
      return new WebCadClouds;
  }
  /* apply(override)
   * 環境をシーンにセットする.
   */
  public apply(scene: Scene): void {
    super.apply(scene);
    scene.me.fog = this._fog;
  }

  /* reset(override)
   * リセット.
   */
  public reset(scene: Scene): void {
    super.reset(scene);
    scene.me.fog = undefined;
  }

  /* cameraChanged
   * カメラが切り替わった.
   */
  public cameraChanged(value: number): void {
    this._camValue = value;
    if (this._fog !== undefined) {
      if (this.night) this._fog.density = WebCadEnvironment._fogNightDensity;
      else this._fog.density = this._camValue > 0 ? WebCadEnvironment._fogWalkThruDensity : WebCadEnvironment._fogOrbitDensity;
    }
  }

  /* update
   * 描画前のアップデート.
   */
  public update(items: ItemManager, cameras: Cameras, timeStamp: number): void {
    if (this.clouds !== undefined) this.clouds.update(cameras, timeStamp);
  }
}

export class HDREnvironment {

  // 環境光作成
  private create(url: string) {
    const pmremGenerator = new THREE.PMREMGenerator(ThreeView.get().wcRenderer.me);
    pmremGenerator.compileEquirectangularShader();

    return new Promise((resolve, reject) => {
      new RGBELoader().load(url, (texture) => {
        const envMap: THREE.Texture = pmremGenerator.fromEquirectangular( texture ).texture;
        pmremGenerator.dispose();

        resolve(envMap);

      }, undefined, reject);
    });
  }

  // 環境に光源をセット
  public apply(scene: Scene, url: string) {
    this.create(url).then((envMap: THREE.Texture) => {
      scene.me.environment = envMap;
      scene.me.background = envMap;
    });
  }

  public applyEnviroment(scene: Scene, url: string) {
    this.create(url).then((envMap: THREE.Texture) => {
      scene.me.environment = envMap;
    });
  }
  public applyBackground(scene: Scene, url: string) {
    this.create(url).then((envMap: THREE.Texture) => {
      scene.me.background = envMap;
    });
  }

  private createEnvmapFromScene(scene: THREE.Scene) {
    const pmremGenerator = new THREE.PMREMGenerator(ThreeView.get().wcRenderer.me);
    pmremGenerator.compileEquirectangularShader();

    return new Promise((resolve) => {
        const envMap: THREE.Texture = pmremGenerator.fromScene( scene ).texture;
        pmremGenerator.dispose();
        resolve(envMap);
      });
  }

  public applyScene(scene: Scene, envscene: THREE.Scene) {
    this.createEnvmapFromScene(envscene).then((envMap: THREE.Texture) => {
        scene.me.environment = envMap;
        // scene.me.background = envMap;
        this.lightAdjust();
      });
  }

  // 光源の調節
  private lightAdjust() {
    const renderer = ThreeView.get().wcRenderer._instance;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 0.3;
  }

  // リセット
  public reset(scene: Scene) {
    scene.me.environment = null;
    scene.me.background = null;
  }

}
